import React, { useEffect, useState } from 'react'
import * as InterialStyle from "../../styles/dabin/StyledComponenetInterialRenewal";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

// 브랜드 로고
import logo_verpan from "../../images/interiorRenewalSplash/logo_verpan.png"
import logo_luceplan from "../../images/interiorRenewalSplash/logo_luceplan.png"
import logo_artemide from "../../images/interiorRenewalSplash/logo_artemide.png"
import logo_lyfa from "../../images/interiorRenewalSplash/logo_lyfa.png"
import logo_vibia from "../../images/interiorRenewalSplash/logo_vibia.png"
import logo_flos from "../../images/interiorRenewalSplash/logo_flos.png"

import image_verpan from "../../images/interiorRenewalSplash/image_verpan.jpg"
import image_luceplan from "../../images/interiorRenewalSplash/image_luceplan.jpg"
import image_artemide from "../../images/interiorRenewalSplash/image_artemide.jpg"
import image_lyfa from "../../images/interiorRenewalSplash/image_lyfa.jpg"
import image_vibia from "../../images/interiorRenewalSplash/image_vibia.jpg"
import image_flos from "../../images/interiorRenewalSplash/image_flos.jpg"

const InteriorRenewalBrand = () => {
  const cards = [
    {image:image_verpan, brand:logo_verpan, slogan:"베르너 팬톤의 감각, 그대로"},
    {image:image_luceplan, brand:logo_luceplan, slogan:"이탈리아의 장인정신을 조명하다"},
    {image:image_artemide, brand:logo_artemide, slogan:"빛으로 삶을 디자인하다"},
    {image:image_lyfa, brand:logo_lyfa, slogan:"건축적 미감과 기능성을 담다"},
    {image:image_vibia, brand:logo_vibia, slogan:"빛으로 그리는 공간의 윤곽"},
    {image:image_flos, brand:logo_flos, slogan:"빛, 예술이 되다"},
  ]
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [slidesPerView, setSlidesPerView] = useState(3.5);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenWidth < 500) {
      setSlidesPerView(1.5);
    } else if (screenWidth <= 770) {
      setSlidesPerView(2.5);
    } else {
      setSlidesPerView(3.5);
    }
  }, [screenWidth]);

  return (
    <div>
      <InterialStyle.InteriorRenewalBrandContainer>
        <div className="brand-text-box">
          <h3>디자이너들의 선택의 이유</h3>
          <h2><span>덴마크, 이탈리아, 스페인 </span>프리미엄 조명의 정수</h2>
        </div>
        <button 
          className='brand-catalog-button'
          onClick={()=>window.open('https://pick.ambience.kr/product', '_blank')}
        >
          전체 제품 카탈로그 확인
        </button>
        <div className="brand-card-box">
          <Swiper
            spaceBetween={20}
            slidesPerView={slidesPerView}
            loop={true}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            navigation={false}
          >
            {cards.map((tmp, idx) => {
              return(
                <SwiperSlide
                key={idx}
                >
                  <img 
                    src={tmp.image} 
                    alt="card-img"
                    className='brand-card-image'
                  />
                  <img 
                    src={tmp.brand} 
                    alt="card-logo"
                    className='brand-card-logo'
                  />
                  <p className='brand-card-slogan'>{tmp.slogan}</p>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
        <div className="slider-container">
    </div>

      </InterialStyle.InteriorRenewalBrandContainer>
    </div>
  )
}

export default InteriorRenewalBrand